import { render, staticRenderFns } from "./tit-wrap-small.vue?vue&type=template&id=6f032eb2&scoped=true&"
import script from "./tit-wrap-small.vue?vue&type=script&lang=js&"
export * from "./tit-wrap-small.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f032eb2",
  null
  
)

export default component.exports